import { type USPBannerData } from '@finn/ui-cosmic';
import { isMobileApp } from '@finn/ui-utils';
import React, { ReactNode } from 'react';

import PLPBanners from '~/components/PLPBanners/PLPBanners';
import PLPBreadcrumbs from '~/components/PLPTitle/PLPBreadcrumbs';
import PLPTitle from '~/components/PLPTitle/PLPTitle';
import { BaseLandingPage, PLPPageData } from '~/types/cosmicModules';

/**
 * In some cases(for example when web app used as webview inside of mobile app)
 * we want to be able to hide/reshuffle some PLP elements.
 * So by allowing SeoRelevantPLP to accept renderMetaContent prop, we able to create
 * alternative pages where we hide this meta content or replacing it with smth else
 */

type MetaContentProps = {
  renderMetaContent: (
    pageData: BaseLandingPage['pageData'],
    { uspBanner }: { uspBanner: USPBannerData }
  ) => ReactNode;
  pageData: PLPPageData;
  uspBanner: USPBannerData;
  isOutOfStock?: boolean;
};

const MetaContent: React.FC<MetaContentProps> = ({
  renderMetaContent,
  pageData,
  uspBanner,
}) => {
  return renderMetaContent ? (
    <>{renderMetaContent(pageData, { uspBanner })}</>
  ) : (
    <>
      <PLPBanners pageData={pageData} uspBanner={uspBanner} />
      {!isMobileApp() ? <PLPBreadcrumbs /> : null}
      {!isMobileApp() ? <PLPTitle /> : null}
    </>
  );
};

export default React.memo(MetaContent);
